import React from "react";
import { Helmet } from "react-helmet-async";
import "./notFound.styles.css";
import { Link } from "react-router-dom";
import { useSEO } from "../../hooks/useSEO";

const NotFoundPage = () => {
  const seo = useSEO();
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {seo}
      <div className="not-found-page">
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <Link to="/" className="home-link">
          Go to Homepage
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
